
        var result = require("!!../node_modules/css-loader/dist/cjs.js??ref--8-1!../node_modules/sass-loader/lib/loader.js??ref--8-2!./app.component.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    